import { AlertPreviewDto } from './types';
import { statusConfig } from '@/app/Alert/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isValidStatus = (status: any): status is keyof typeof statusConfig => {
  return typeof status === 'string' && status in statusConfig;
};

export const getStatusConfig = (status: string | undefined) => {
  if (!status || !isValidStatus(status)) {
    return statusConfig.Unknown;
  }
  return statusConfig[status];
};

export const sortAlerts = (alerts: AlertPreviewDto[]): AlertPreviewDto[] => {
  return alerts.sort((a, b) => {
    // // Prioritize 'Intruder' status
    // if (a.status === 'Intruder' && b.status !== 'Intruder') return -1;
    // if (b.status === 'Intruder' && a.status !== 'Intruder') return 1;

    // For non-Intruder alerts or when both are Intruders, sort by occurrence time
    return new Date(b.occurred || 0).getTime() - new Date(a.occurred || 0).getTime();
  });
};

export const formatTimeAgo = (date: Date | string | undefined): string => {
  if (!date) return '';
  const now = new Date();
  const alertDate = new Date(date);
  const diffInSeconds = Math.floor((now.getTime() - alertDate.getTime()) / 1000);

  if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ago`;
  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays}d ago`;
};

/** @deprecated Use `<Time>` component from `@/components/ui/time` instead */
export const formatDate = (date: Date | string | undefined): string => {
  if (!date) return '';
  const alertDate = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(alertDate);
};
